module.exports = __webpack_public_path__ + "img/lake-village-map-mobile--en.68cc77c0.png";